module.exports = __webpack_public_path__ + "img/SP.b3964a3c.png";